import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Hero from "../components/home/Hero";
import FilmFrame from "../components/home/FilmFrame";
import TrustedStrip from "../components/home/TrustedStrip";
import StatsBand from "../components/home/StatsBand";
import HowWeWork from "../components/home/HowWeWork";
import Process from "../components/home/Process";
import FeaturedWork from "../components/home/FeaturedWork";
import FormatsCloud from "../components/home/FormatsCloud";
import Clients from "../components/home/Clients";
import WhyUs from "../components/home/WhyUs";
import Faq from "../components/home/Faq";
import FinalCta from "../components/home/FinalCta";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <FilmFrame />
      <TrustedStrip />
      <StatsBand />
      <HowWeWork />
      <Process />
      <FeaturedWork />
      <FormatsCloud />
      <Clients />
      <WhyUs />
      <Faq />
      <FinalCta />
      <Footer />
    </main>
  );
}
